import React, { useState, useEffect } from 'react';
import Button from '../../../../components/Button/Button';
import ButtonSecondary from '../../../../components/Button/ButtonSecondary';
import InputField from '../../../../components/InputField/InputField';
import ImportModal from '../../../../components/ImportModal/ImportModal';
import SideBar from '../../../../components/SideBar/SideBar';
import qs from 'query-string';
import { Screen, Container } from './styles';
import { Link, useLocation } from 'react-router-dom';
import {
  createTemplate,
  editTemplate,
  getProducts,
  getTemplate as getTemplateCall,
  exportPriceTemplate,
  importPriceTemplate
} from '../../../../api';

const initialValue = {
  id: '',
  name: '',
  productPrices: []
};

const ManageTemplate = (props) => {
  let e = useLocation();
  const params = qs.parse(e.search);
  const [results, setResults] = useState(initialValue);
  const [productPrices, setProductPrices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const handleChange = (e) => {
    setResults({ ...results, [e.target.name]: e.target.value });
  };

  const handlePriceChange = (e) => {
    let prices = productPrices;
    const index = prices.findIndex((p) => {
      return p.productId == parseInt(e.target.name);
    });

    prices[index].price = e.target.value;
    setProductPrices(prices);
    setResults({ ...results, productPrices: prices });
  };

  useEffect(() => {
    const getAllProducts = async (template) => {
      const { data } = await getProducts();
      let prices = [];
      let products = template ? template.Product_Prices : [];
      for (let i = 0; i < data.length; i++) {
        const product = data[i];

        const index = products.findIndex((p) => {
          return p.productId == product.id;
        });

        const price = index > -1 ? products[index].price : 0;
        prices.push({ productId: product.id, price, name: product.name });
      }
      setProductPrices(prices);
      setResults({
        id: template?.id,
        name: template?.name,
        productPrices: prices
      });
    };

    const getTemplate = async () => {
      const { data } = await getTemplateCall(params.id);

      getAllProducts(data);
    };

    if (params.id) {
      getTemplate();
    } else {
      getAllProducts();
    }
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    if (params.id) {
      await editTemplate(params.id, results);
    } else {
      await createTemplate(results);
    }
    setIsLoading(false);
    window.location.href = '/manage/templates';
  };

  const handleExport = async () => {
    const { data } = await exportPriceTemplate(params.id);


    console.log(data);
    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', `Template ${results.name}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleImport = () => {
    setShowImportModal(true);
  };

  const handleImportSubmit = async (templateId, file) => {
    const response = await importPriceTemplate(templateId, file);

    // Refresh the template data after successful import
    const { data } = await getTemplateCall(params.id);
    const productsResponse = await getProducts();

    let prices = [];
    let templateProducts = data.Product_Prices || [];

    for (let i = 0; i < productsResponse.data.length; i++) {
      const product = productsResponse.data[i];
      const index = templateProducts.findIndex((p) => p.productId == product.id);
      const price = index > -1 ? templateProducts[index].price : 0;
      prices.push({ productId: product.id, price, name: product.name });
    }

    setProductPrices(prices);
    setResults({
      id: data.id,
      name: data.name,
      productPrices: prices
    });

    return response;
  };

  return (
    <>
      <Screen>
        <Container>
          <h3>{params.id ? 'Edit' : 'Add'} Price Template</h3>
          <div className='detailInput templateName'>
            <label>Name</label>
            <InputField
              name='name'
              placeholder='Name'
              onChange={handleChange}
              value={results.name}
            />
          </div>

          <div className='buttons'>
            <ButtonSecondary
              title='Import'
              onClick={handleImport}
            />
            <Button
              disabled={isLoading}
              title={isLoading ? 'Exporting...' : 'Export'}
              onClick={handleExport}
            />
          </div>

          <hr style={{ width: '100%', margin: '20px 0' }} />
          {productPrices.map((product) => {
            return (
              <div>
                <div className='detailInput'>
                  <label>{product.name}</label>
                  <InputField
                    name={product.productId}
                    placeholder='Price'
                    onChange={handlePriceChange}
                    type='number'
                    value={product.price}
                  />
                </div>
              </div>
            );
          })}
          <div className='buttons' style={{ marginTop: '20px' }}>
            <Link to={`/manage/templates`}>
              <ButtonSecondary title='Cancel' />
            </Link>
            <Button
              disabled={isLoading}
              title={isLoading ? 'Saving...' : params.id ? 'Save' : 'Add'}
              onClick={handleSubmit}
            />
          </div>
        </Container>
      </Screen>

      <ImportModal
        visible={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImport={handleImportSubmit}
        templateId={params.id}
        templateName={results.name}
      />
    </>
  );
};

export default ManageTemplate;
